import {
    TRANSLATIONS,
    SUPPORTED_LANGUAGES,
    LANGUAGE_LABELS
  } from "./translations.js";
  
  import {
    getSavedLanguage,
    saveLanguage
  } from "../services/addinStorage.js";
  
  let currentLanguage = "en";
  
  function normalizeLanguage(value) {
    const raw = String(value || "").toLowerCase();
  
    if (!raw) return "en";
  
    const shortCode = raw.split("-")[0];
  
    return SUPPORTED_LANGUAGES.indexOf(shortCode) >= 0 ? shortCode : "en";
  }
  
  export function detectInitialLanguage() {
    const saved = getSavedLanguage();
  
    if (saved) {
      return normalizeLanguage(saved);
    }
  
    const officeLanguage =
      window.Office &&
      window.Office.context &&
      window.Office.context.displayLanguage;
  
    const browserLanguage =
      navigator.language ||
      navigator.userLanguage ||
      "";
  
    return normalizeLanguage(officeLanguage || browserLanguage || "en");
  }
  
  export function setLanguage(language) {
    currentLanguage = normalizeLanguage(language);
    saveLanguage(currentLanguage);
    document.documentElement.setAttribute("lang", currentLanguage);
    return currentLanguage;
  }
  
  export function getLanguage() {
    return currentLanguage;
  }
  
  export function getLanguageLabels() {
    return LANGUAGE_LABELS;
  }
  
  export function t(key, params) {
    const dictionary = TRANSLATIONS[currentLanguage] || TRANSLATIONS.en;
    const fallback = TRANSLATIONS.en || {};
  
    let value = dictionary[key] || fallback[key] || key;
  
    if (params) {
      for (const name in params) {
        if (Object.prototype.hasOwnProperty.call(params, name)) {
          value = value.replace(
            new RegExp("\\{" + name + "\\}", "g"),
            String(params[name])
          );
        }
      }
    }
  
    return value;
  }
  
  export function localizeElementText(id, key) {
    const el = document.getElementById(id);
    if (el) el.textContent = t(key);
  }
  
  export function localizeElementPlaceholder(id, key) {
    const el = document.getElementById(id);
    if (el) el.setAttribute("placeholder", t(key));
  }
  
  export function localizeSelectOption(selectId, value, key) {
    const select = document.getElementById(selectId);
    if (!select) return;
  
    for (let i = 0; i < select.options.length; i += 1) {
      if (select.options[i].value === value) {
        select.options[i].text = t(key);
        return;
      }
    }
  }